import * as S from "./InputAlerts.styled";
import { InlineAlert, type InlineAlertProps } from "../InlineAlert";

export type InputAlertsProps = {
  slot?: string;
  alerts: Omit<InlineAlertProps, "withRole">[];
};

function InputAlerts(props: InputAlertsProps) {
  const { slot = "errorMessage", alerts } = props;

  return (
    <S.Container elementType="div" slot={slot}>
      {alerts.map((alertProps) => (
        <InlineAlert
          key={alertProps.children}
          withRole={false}
          {...alertProps}
        />
      ))}
    </S.Container>
  );
}

export default InputAlerts;
